import React from 'react';
import { automaticLinkLabel, externalLinkSegments } from '../../utils/externalLinkText';
import ExternalLink from './index';

// Plain-text fields use the same destination checks, previews and appearance
// as comment links. Keep surrounding whitespace as text so biography line
// breaks survive without converting saved profile data to HTML.
export default function LinkText({ value }) {
  return externalLinkSegments(value).map((segment, index) => segment.href
    ? <ExternalLink key={`${index}:${segment.href}`} href={segment.href}
        label={segment.text} customLabel={segment.customLabel || automaticLinkLabel(segment.href)} />
    : <React.Fragment key={index}>{segment.text}</React.Fragment>);
}
